import { array, object, string } from 'yup'
import { t } from 'ttag'

import {
  DEADLINE_FIELD,
  KIND_FIELD,
  MESSAGES_FIELD,
  MESSAGE_FIELD,
  RECEIVER_FIELD,
  SENDER_FIELD,
  SUBJECT_FIELD,
  TEMPLATE_ID_FIELD,
} from './model'

export const getSchema = () =>
  object().shape({
    [MESSAGES_FIELD]: array().of(
      object().shape({
        [DEADLINE_FIELD]: string().required(t`This field cannot be empty.`),
        [KIND_FIELD]: string().required(t`This field cannot be empty.`),
        [RECEIVER_FIELD]: string().required(t`This field cannot be empty.`),
        [SENDER_FIELD]: string().required(t`This field cannot be empty.`),
        [SUBJECT_FIELD]: string().required(t`This field cannot be empty.`),
        [MESSAGE_FIELD]: string().required(t`This field cannot be empty.`),
        [TEMPLATE_ID_FIELD]: string().required(t`This field cannot be empty.`),
      }),
    ),
  })
